import { gql } from "@apollo/client";

export const PAYOUT_2FA_GENERATE_MUTATION = gql(`
    mutation GeneratePTFA {
      generatePTFA {
        uri
        secret
      }
    }
`);
